// src/api/pfReturn.ts
//
// One wage month's PF (EPFO ECR) return cycle. Every step's state is DERIVED
// by hrms_prod from facts read off the portal — this client never computes or
// stores "step 3 is done", it only renders what the backend worked out.
import api from "./api";

export type PfStepKey = "prepare" | "upload" | "approve" | "challan" | "file";

// "blocked" is step 1 only (the data itself is not ready); "locked" means the
// step before it is not done yet.
export type PfStepState = "done" | "current" | "locked" | "blocked";

export interface PfStep {
  key: PfStepKey;
  title: string;
  state: PfStepState;
}

export type PfBlocker = "salary_not_approved" | "uan_missing" | "no_members";

export interface PfReadiness {
  members: number;
  epf_contribution: number;
  eps_contribution: number;
  // Named, because an employee with no UAN is silently left out of the filing
  // and the portal's active-member count then stops matching.
  missing_uan: string[];
  not_approved: { records: number; net: number };
  blockers: PfBlocker[];
  ready: boolean;
}

export interface PfPortalFacts {
  return_file_id: string | null;
  return_type: string | null;
  contribution_rate: string | null;
  uploaded_on: string | null;
  portal_status: string | null;
  portal_status_at: string | null;
  // False when the portal said something hrms_prod has never been taught to
  // read. The UI shows the text itself rather than guessing what it means.
  portal_status_recognised: boolean;
  approved_at: string | null;
  trrn: string | null;
  challan_reference: string | null;
  challan_amount: number | null;
  challan_paid_at: string | null;
}

export interface PfReturnState {
  year: number;
  month: number;
  steps: PfStep[];
  readiness: PfReadiness;
  portal: PfPortalFacts | null;
}

export const pfReturnApi = {
  get: (year: number, month: number) =>
    api.get<PfReturnState>(`/pf-return`, { params: { year, month } }),
};
